module.exports = "<div class=\"loader-overlay\">\r\n  <div class=\"loader\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/redirect-page/redirect-page.component.html
// module id = ./src/app/pages/redirect-page/redirect-page.component.html
// module chunks = main